<template>
    <div :class="[containerClass, 'cursor-pointer', 'd-inline-block']" @click="flipAndUpdate">
        <div class="checkbox-inline user-select-none pointer-events-none">
            <label class="checkbox" :class="[typeClass]">
                <input type="checkbox" v-model="checked" @change="update">
                <span v-if="checked" :style="bgColorStyle" :class="[bgColorClass]" class="mr-2"/>
                <span v-else class="mr-2"/>
                <slot/>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        type: {
            type: String,
            default: 'primary'
        },
        bgColor: String,
        bgColorClass: String,
        formControlSolid: Boolean,
        formControl: Boolean,
    },

    data() {
        return {
            checked: null
        }
    },

    mounted() {
        this.checked = this.value;
    },

    methods: {
        flipAndUpdate() {
            this.checked = !this.checked;
            this.update();
        },

        update() {
            this.$emit('input', this.checked)
        }
    },

    computed: {
        typeClass() {
            if (this.type) {
                return `checkbox-${this.type}`
            }

            return null;
        },

        bgColorStyle() {
            if (this.bgColor) {
                return `background-color: ${this.bgColor};`
            }

            return null;
        },

        containerClass() {
            if (this.formControlSolid) {
                return 'pt-3 pb-2 px-4 bg-light-light rounded';
            } else if (this.formControl) {
                return 'pt-3 pb-2 px-4 border border-light-secondary rounded';
            }

            return '';
        }
    }
}
</script>
